import * as t from "io-ts";
import nullable from "./nullable";
export const accountDimensionT = t.keyof({
    TRUCK: null,
    TRAILER: null,
    DRIVER: null,
    CLIENT: null,
});
export const periodSummaryT = t.strict({
    orders: t.number,
    routes: t.number,
    driverArrivals: t.number,
    invoicedCargos: t.number,
    notInvoicedCargos: t.number,
});
export const orderManualCostT = t.strict({
    id: t.string,
    description: t.string,
    amount: t.number,
    date: t.string,
    categoryId: nullable(t.string),
});
export const orderRowT = t.strict({
    cargoId: t.string,
    date: nullable(t.string),
    cargoRef: nullable(t.string),
    description: nullable(t.string),
    fromCity: nullable(t.string),
    toCity: nullable(t.string),
    clientId: nullable(t.string),
    clientName: nullable(t.string),
    vehicleId: nullable(t.string),
    vehicleName: nullable(t.string),
    trailerId: nullable(t.string),
    driverIds: t.array(t.string),
    manualCosts: t.array(orderManualCostT),
    manualCostsTotal: t.number,
});
export const orderRowsT = t.array(orderRowT);
export const ruleCostLineT = t.strict({
    name: t.string,
    rate: t.number,
    quantity: t.number,
    unit: t.string,
    amount: t.number,
});
export const entityAccountT = t.strict({
    entityId: t.string,
    entityName: nullable(t.string),
    orderCount: t.number,
    activeDays: t.number,
    km: t.number,
    totalWeight: t.number,
    revenue: t.number,
    manualCosts: t.number,
    ruleCosts: t.number,
    ruleBreakdown: t.array(ruleCostLineT),
    totalCosts: t.number,
    result: t.number,
});
export const entityAccountsT = t.array(entityAccountT);
export const monthlyTotalT = t.strict({
    month: t.string,
    orders: t.number,
    revenue: t.number,
    manualCosts: t.number,
});
export const monthlyTotalsT = t.array(monthlyTotalT);
export const co2MonthT = t.strict({
    month: t.string,
    kg: t.number,
    tkm: t.number,
});
export const namedValueT = t.strict({
    name: nullable(t.string),
    value: t.number,
});
export const co2ResponseT = t.strict({
    monthly: t.array(co2MonthT),
    byVehicle: t.array(namedValueT),
});
export const geoRowT = t.strict({
    name: nullable(t.string),
    orders: t.number,
    revenue: t.number,
});
export const geographyResponseT = t.strict({
    byCountry: t.array(geoRowT),
    byCity: t.array(geoRowT),
});
export const invoicingStatsT = t.strict({
    invoiced: t.number,
    notInvoiced: t.number,
    avgDaysToInvoice: nullable(t.number),
});
export const productMixRowT = t.strict({
    name: nullable(t.string),
    revenue: t.number,
    qty: t.number,
});
export const productMixRowsT = t.array(productMixRowT);
export const utilizationRowT = t.strict({
    name: nullable(t.string),
    totalKm: t.number,
    loadedKm: t.number,
});
export const utilizationRowsT = t.array(utilizationRowT);
export const insightProductOptionT = t.strict({
    id: t.string,
    name: nullable(t.string),
});
export const insightProductOptionsT = t.array(insightProductOptionT);
//# sourceMappingURL=insights.js.map